import COOKIES_STORAGE from '../configs/cookiesStorage';
import { groupArrayOfObject } from './commonUtils';

const { LOCAL_STORAGE } = COOKIES_STORAGE;

export const isAccessGroupExist = ({ slug }) => {
  // const adminRolesDummy = [
  //   {
  //     name: 'List Payment',
  //     slug: 'list-payment',
  //   },
  //   {
  //     name: 'List License',
  //     slug: 'list-license',
  //   },
  //   {
  //     name: 'List Team',
  //     slug: 'list-team',
  //   },
  //   {
  //     name: 'Create User',
  //     slug: 'create-user',
  //   },
  //   {
  //     name: 'Edit Team',
  //     slug: 'edit-team',
  //   },
  //   {
  //     name: 'Invite or Remove Team Member',
  //     slug: 'invite-team-member',
  //   },
  //   {
  //     name: 'Create Payment',
  //     slug: 'create-payment',
  //   },
  //   {
  //     name: 'Create Team',
  //     slug: 'create-team',
  //   },
  //   {
  //     name: 'List User',
  //     slug: 'list-user',
  //   },
  //   {
  //     name: 'Manage Role',
  //     slug: 'manage-role',
  //   },
  //   {
  //     name: 'Update User',
  //     slug: 'edit-user',
  //   },
  //   {
  //     name: 'Accept Payment',
  //     slug: 'accept-payment',
  //   },
  //   {
  //     name: 'Edit License',
  //     slug: 'edit-license',
  //   },
  // ];
  const userRoles = localStorage.getItem(LOCAL_STORAGE.USER_RULES);
  // const userRoles = adminRolesDummy;
  if (userRoles) {
    const userAccessGroups = JSON.parse(userRoles);
    const isFound = userAccessGroups.some((item) => {
      return item.slug === slug;
    });
    // const isFound = userRoles.some((item) => {
    //   return item.slug === slug;
    // });
    return isFound;
  }

  return false;
};

export const isTeamAccessGroupExist = ({ slug }) => {
  // const teamRolesDummy = [
  //   {
  //     name: 'list members',
  //     slug: 'list-members',
  //   },
  //   {
  //     name: 'invite remove team member',
  //     slug: 'invite-remove-team-member',
  //   },
  //   {
  //     name: 'manage team roles',
  //     slug: 'manage-team-roles',
  //   },
  //   {
  //     name: 'team setting',
  //     slug: 'team-setting',
  //   },
  //   {
  //     name: 'team license',
  //     slug: 'team-license',
  //   },
  //   {
  //     name: 'create team payment',
  //     slug: 'create-team-payment',
  //   },
  //   {
  //     name: 'payment history',
  //     slug: 'payment-history',
  //   },
  //   {
  //     name: 'list social accounts',
  //     slug: 'list-social-account',
  //   },
  //   {
  //     name: 'social accounts',
  //     slug: 'social-account',
  //   },
  //   {
  //     name: 'list contacts',
  //     slug: 'list-contacts',
  //   },
  //   {
  //     name: 'create contact',
  //     slug: 'create-contact',
  //   },
  //   {
  //     name: 'edit contact',
  //     slug: 'edit-contact',
  //   },
  //   {
  //     name: 'list campaign',
  //     slug: 'list-campaign',
  //   },
  //   {
  //     name: 'create campaign',
  //     slug: 'create-campaign',
  //   },
  //   {
  //     name: 'Edit Promoter',
  //     slug: 'edit-campaign',
  //   },
  //   {
  //     name: 'List Ads Set',
  //     slug: 'list-ads-set',
  //   },
  //   {
  //     name: 'Create Ads Set',
  //     slug: 'create-ads-set',
  //   },
  //   {
  //     name: 'Edit Ads Set',
  //     slug: 'edit-ads-set',
  //   },
  //   {
  //     name: 'List Ads',
  //     slug: 'list-ads',
  //   },
  //   {
  //     name: 'Create Ads',
  //     slug: 'create-ads',
  //   },
  //   {
  //     name: 'Edit Ads',
  //     slug: 'edit-ads',
  //   },
  //   {
  //     name: 'Integrator',
  //     slug: 'integrator',
  //   },
  //   {
  //     name: 'Create Integrator',
  //     slug: 'create-integrator',
  //   },
  //   {
  //     name: 'Edit integrator',
  //     slug: 'edit-integrator',
  //   },
  //   {
  //     name: 'Integrator',
  //     slug: 'integrator-approval',
  //   },
  //   {
  //     name: 'List Analyzer',
  //     slug: 'list-analyzer',
  //   },
  //   {
  //     name: 'Create Analyzer',
  //     slug: 'create-analyzer',
  //   },
  //   {
  //     name: 'List Refiner',
  //     slug: 'list-refiner',
  //   },
  //   {
  //     name: 'Create Refiner',
  //     slug: 'crate-refiner',
  //   },
  //   {
  //     name: 'Insert Redemption Data',
  //     slug: 'insert-redemption-data',
  //   },
  // ];
  // const teamRoles = teamRolesDummy;
  const teamRoles = localStorage.getItem(LOCAL_STORAGE.TEAM_ROLE);
  if (teamRoles) {
    const teamAccessGroups = JSON.parse(teamRoles);
    const isFound = teamAccessGroups.some((item) => {
      return item.slug === slug;
    });
    // const isFound = teamRoles.some((item) => {
    //   return item.slug === slug;
    // });
    return isFound;
  }
  return false;
};

export const filteredMenuByAccessGroup = ({ menus = [] }) => {
  return menus.filter((item) => {
    return item.hasAccess;
  });
};

export const onParseAccessGroup = (accessGroup, accessGroupConfig) => {
  const classification = accessGroup?.map((item) => {
    const find = accessGroupConfig?.find((rule) => {
      return rule?.slugs?.includes(item?.slug);
    });
    if (find) return { ...item, class: find?.class };
    return { ...item, class: 'others' };
  });

  const grouping = groupArrayOfObject(classification, 'class');
  const options = accessGroupConfig?.map((item) => {
    const rules = grouping[item?.class] || [];
    return { ...item, rules };
  });
  const filtered = options?.filter((item) => {
    return item?.rules?.length !== 0;
  });
  return filtered;
};
